import type { VoucherSortField, VoucherStatus } from '@/gql/graphql';
import { int, oneOf, text } from '@/hooks/useUrlState';
import { voucherStatusLabel } from '@/lib/labels';

/** Every `VoucherStatus` in the order the filter lists them, with its label. */
export const VOUCHER_STATUS_LABELS: Record<VoucherStatus, string> = {
  ISSUED: voucherStatusLabel('ISSUED'),
  RESERVED: voucherStatusLabel('RESERVED'),
  REDEEMED: voucherStatusLabel('REDEEMED'),
  EXPIRED: voucherStatusLabel('EXPIRED'),
  REVOKED: voucherStatusLabel('REVOKED'),
  FORFEITED: voucherStatusLabel('FORFEITED'),
};

export type VouchersSortColumn = 'issuedAt' | 'expiresAt' | 'status';

/** DataGrid column `id` → GraphQL sort field for server-side sort; its keys are the values `sort` accepts. */
export const VOUCHER_COLUMN_SORT: Record<VouchersSortColumn, VoucherSortField> = {
  issuedAt: 'ISSUED_AT',
  expiresAt: 'EXPIRES_AT',
  status: 'STATUS',
};

export const VOUCHERS_DEFAULT_SORT: { sort: VouchersSortColumn; dir: 'asc' | 'desc' } = { sort: 'issuedAt', dir: 'desc' };

/** The /vouchers query string, in this order (see README "List pages, URL state"). */
export const vouchersUrlSchema = {
  search: text(),
  status: oneOf(VOUCHER_STATUS_LABELS, ''),
  sort: oneOf(VOUCHER_COLUMN_SORT, VOUCHERS_DEFAULT_SORT.sort),
  dir: oneOf<'asc' | 'desc', 'asc' | 'desc'>({ asc: true, desc: true }, VOUCHERS_DEFAULT_SORT.dir),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 25),
};
